export const STORES = {
  drukwerkdeal: 'drukwerkdeal-nl',
  printdeal: 'printdeal-be',
  impressto: 'impressto-fr',
};

export const ALGOLIA_TYPES = {
  PDP_INDEX: 'ProductPages',
  PDP_INDEX_END_USER: 'ProductPages_Endusers',
  PDP_INDEX_RESELLER: 'ProductPages_Resellers',
  PROD_CAT_INDEX: 'ProductCategories',
  CONTENT_PAGES_INDEX: 'ContentPages',
  HELP_CENTER_INDEX: 'HelpCenterArticles',
  PRODUCT_QUERY_SUGGESTIONS_NL_NL: 'ProductPages_query_suggestions_nl-NL',
  PRODUCT_QUERY_SUGGESTIONS_NL_BE: 'ProductPages_query_suggestions_nl-BE',
  PRODUCT_QUERY_SUGGESTIONS_FR_BE: 'ProductPages_query_suggestions_fr-BE',
  PRODUCT_QUERY_SUGGESTIONS_FR_FR: 'ProductPages_query_suggestions_fr-FR',
};
